import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleKey, ModulePermissions } from '../shared/models/module-permissions.model';
import { GetModulePermissionsGQL } from '../../../graphql/generated';

@Injectable({ providedIn: 'root' })
export class ModulePermissionsService {
  private readonly getModulePermissionsGQL = inject(GetModulePermissionsGQL);

  getPermissions(): Observable<ModulePermissions> {
    return this.getModulePermissionsGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      map(result => {
        const items = result.data.getModulePermissions?.data?.[0]?.modulePermissions ?? [];
        return items.reduce((acc, item) => {
          if (item?.key) acc[item.key as ModuleKey] = item.enabled ?? false;
          return acc;
        }, {} as ModulePermissions);
      })
    );
  }
}
